
export class ValidateUtil {

	// messageUtilService = new MessageUtilService();

	requerido(obj: any, nombre: string) {
		if (typeof obj == "undefined" || obj == "Invalid date" || obj == null) {
			throw nombre;
		}
	}
	isUndefinedOrNull(obj: any) : boolean{
		if (typeof obj == "undefined" || obj == "Invalid date" || obj == null) {
			return true;
		}

		if(typeof obj == "string" && obj ==''){
			return true;
		}

		return false;
	}
}
